import crypto from "crypto";
/**
 * Decrypts a string using AES-256-GCM.
 *
 * The function expects the `encrypted` string to be formatted as a concatenation of:
 * - IV (base64-encoded, first 16 characters of the input string)
 * - Authentication tag (base64-encoded, next 24 characters)
 * - Ciphertext (base64-encoded, rest of the string; internally decoded twice due to double encoding)
 *
 * The `key` is hashed with SHA-256, truncated to 32 bytes, and used as the AES key.
 *
 * @param {string} encrypted - The encrypted string containing IV, tag, and ciphertext.
 * @param {string} [key=""] - The secret key used for encryption (before SHA-256 hashing).
 * @returns {string} The decrypted plaintext string.
 *
 * @throws {Error} If the decryption fails (e.g., wrong key, corrupted data).
 */

function decryptAES256GCM(encrypted, key = "") {

  const masterkey = key ||  process.env.VUE_APP_GCM_SECRET;

  const password = crypto.createHash("sha256").update(masterkey).digest().subarray(0, 32);

  const ivLenght = 16;
  const tagLenght = 24;

  const iv = Buffer.from(encrypted.substring(0, ivLenght), "base64");
  const tag = Buffer.from(encrypted.substring(ivLenght, ivLenght + tagLenght), "base64");
  const ciphertext = Buffer.from(
    Buffer.from(encrypted.substring(ivLenght + tagLenght), "base64").toString("utf8"),
    "base64"
  );

  const decipher = crypto.createDecipheriv("aes-256-gcm", password, iv);
  decipher.setAuthTag(tag);

  const decrypted = Buffer.concat([
    decipher.update(ciphertext),
    decipher.final()
  ]);

  return decrypted.toString("utf8");
}
export default decryptAES256GCM;
